import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, NgZone, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from "rxjs";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ToastrService, AuthorizationService } from './../../../shared/index';

@Component({
    selector: 'login',
    templateUrl: './login.html',
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('loginModal', { static: true, read: ModalDirective}) loginModal: ModalDirective;
    @ViewChild('forgotPasswordModal', { static: true, read: ModalDirective }) forgotPasswordModal: ModalDirective;
    private authenticatedSubscription: Subscription;
    private authenticateFailedSubscription: Subscription;
    private securityQuestionSubscription: Subscription;

    //@Input() showLoginModal = false;
    @Output() clickCancelLogin = new EventEmitter<boolean>();

    public userNameFocus = false;
    public passwordFocus = false;
    public loginFocus = false;
    public answerFocus = false;
    public userName = '';
    public password = '';
    public forgotPasswordVisible = false;
    public securityQuestion = '';
    public securityQuestionId: number = -1;
    public answer = '';
    private subscriptions: Subscription[] = [];

    constructor(
        protected _router: Router,
        private _authorizationService: AuthorizationService,
        private _toastrService: ToastrService,
        private _ngZone: NgZone
    ) {
    }


    ngOnInit(): void {
        this.userName = this._authorizationService.userName;

        this.subscriptions.push(this.loginModal.onShown.subscribe(() => {
            if (this.userName !== '') {
                this.passwordFocus = true;
            }
            else {
                if (this.password === '') {
                    this.userNameFocus = true;
                }
                else {
                    this.loginFocus = true;
                }
            }
        }));

        this.subscriptions.push(this.forgotPasswordModal.onShown.subscribe(() => {
            if (!this.securityQuestion) {
                this._toastrService.displayToastrMessage("error", "No Security Questions have been answered, please contact an Admin for assistance");
                // uncomment below line to hide login modal as well as showing error
                this.forgotPasswordModal.hide()
                this.cancelLogin()
            }
            else {
                this.passwordFocus = false;
                this.userNameFocus = false;
                this.answerFocus = true;
            }
        }));

        this.subscriptions.push(this._authorizationService.authenticateComplete.subscribe((info: any) => {
            this.authorizeComplete(info);
        }));

        this.subscriptions.push(this._authorizationService.authenticateFailed.subscribe(() => {
            this.authorizeFailed();
        }));

        this.subscriptions.push(this._authorizationService.securityQeustionRetrieved.subscribe((info: any) => {
            this.securityQuestion = info.Question;
            this.securityQuestionId = info.Id;
        }));
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    ngAfterViewInit(): void {
        if (!this._authorizationService.authenticated) {
            this.loginModal.show();
        }
    }

    public login(): void {
        this._authorizationService.authenticate(this.userName, this.password);
    }

    public cancelLogin(): void {
        this.clickCancelLogin.emit(false)
    }

    public submitAnswer(): void {
        this._authorizationService.validateAnswer(this.answer);
        this.answer = '';
    }

    public forgotPassword(): void {
        this._authorizationService.getSecurityQuestion();

        

        this.loginModal.hide();
        this.forgotPasswordModal.show();
    }

    public goBack(): void {
        this.answer = '';
        this.forgotPasswordModal.hide();
        this.loginModal.show();
        this.passwordFocus = true;
    }

    private authorizeComplete(info: any): void {
        this._toastrService.displayToastrMessage('success', 'Login successful! \tWelcome ' + this._authorizationService.fullName + '!', 'Login');
        if (this.forgotPasswordModal.isShown) {
            this.forgotPasswordModal.hide();
        } else {
            this.loginModal.hide();
        }
        this.setCookie('userName', this._authorizationService.fullName);

        this._router.navigate(['/' + this._authorizationService.startPage]);
    }

    private authorizeFailed(): void {
        this._ngZone.run(() => {
            if (!this.forgotPasswordVisible) {
                this.forgotPasswordVisible = true;
            }
            this.answer = '';
            this.password = '';
            this.answerFocus = true;
        });
    }

    private setCookie(name: string, val: string) {
        const date = new Date();
        const value = val;

        // Set it expire in 7 days
        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));

        // Set it
        document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/';
    }
}
